/**
 * The build's version, wherever it is shown.
 *
 * This used to be the literal text `KINESIN_WEB_VERSION` written into each page's JSX, which the
 * deploy workflows rewrote with `sed` — naming the two files they knew about. A third page added
 * later was never added to that list, so it shipped the placeholder to patients for months
 * (KIN-1984). A page cannot opt into a `sed` command it does not know exists.
 *
 * Reading a `REACT_APP_*` variable is how every other build-time value in this app is handled, so
 * a new page showing the version needs nothing but this component.
 */
export const AppVersion = ({ className }) => (
  <div className={className}>
    Kinesin version: {process.env.REACT_APP_VERSION || "local"}
  </div>
);
